import React, { useEffect, useState, useRef } from "react";
import paths from "routes/paths";
import {
  Card,
  Col,
  Row,
  Form,
  Breadcrumb,
  Spinner,
  OverlayTrigger,
  Tooltip,
  Modal,
  Button,
  Tab,
  Tabs,
  ListGroup,
  Badge,
  Dropdown,
  Table,
  Collapse,
} from "react-bootstrap";
import { useNavigate, useParams, Link, useLocation } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { useTranslation } from "react-i18next";
import IconButton from "components/common/iconButton";
import SubtleBadge from "components/common/subtleBadge";
import Background from "components/common/background";
import corner4 from "assets/img/illustrations/corner-4.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStream, faCheck, faBan, faStar } from "@fortawesome/free-solid-svg-icons";
import FalconCloseButton from "components/common/falconCloseButton";
import { toast } from "react-toastify";
import { fetchRoleMappings } from "../../assets/js/common";
import Select from "react-select";
import { v4 as uuidv4 } from "uuid";
import FullCalendar from '@fullcalendar/react';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import interactionPlugin from '@fullcalendar/interaction';
import ReactDOMServer from 'react-dom/server';
import {
  fetchRoleAndClaims, handleLoadingAndAccess, renderTaskStatusBadge, CleanerDeleteModal,
  deleteCleanerByOrderDetailId, deleteAllCleanerOrderDetailsForDay, dispatchBatchNotification,
  fetchLeaveConflictMap, combineDateAndTimeOfDay, checkEmployeeAvailability,
  SchedulingIssuesModal, fetchRecommendedEmployees, partitionRecommendedEmployees,
  sortEmployeesAscending, clearEmployeeAvailabilityCache
} from "../../assets/js/common";
import TaskDrawer from '../calender/taskDrawer';
import UnavailabilitySidepanel from '../calender/unavailabilitySidepanel';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import InspectionLog from "./inspectionLog";
import OrderHistory from "./orderHistory";
import Inventory from "./inventory";
import Overview from "./overview";
import PDFVierwer from "../proposals/pdfVierwer";

const OrderDetails = () => {
  const { orderId: orderIdParam } = useParams();
  const orderId = (orderIdParam || "").toUpperCase();
  const location = useLocation();
  const pageLoadStartRef = useRef(performance.now());
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedTask, setSelectedTask] = useState(null);
  const [weekStart, setWeekStart] = useState(null);
  const [showOrderDeleteModal, setShowOrderDeleteModal] = useState(false);
  const toastShownRef = useRef(false);
  const [allEmployees, setAllEmployees] = useState([]);
  const weekStartRef = useRef(null);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedDateForAssign, setSelectedDateForAssign] = useState(null);
  const [selectedCleaners, setSelectedCleaners] = useState([]);
  const [taskWithSubtasks, setTaskWithSubtasks] = useState([]);
  const [selectedProposalTask, setSelectedProposalTask] = useState(null);
  const calendarRef = useRef(null);
  const [calendarReady, setCalendarReady] = useState(false);
  const [relationData, setRelationData] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const userRole = localStorage.getItem("UserRole");
  const currentUserId = localStorage.getItem("UserId");
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [isAssigning, setIsAssigning] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [showCleanerDeleteModal, setShowCleanerDeleteModal] = useState(false);
  const [selectedOrderDetailId, setSelectedOrderDetailId] = useState(null);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [selectedTaskDate, setSelectedTaskDate] = useState(null);
  const skipAutoWeekResetRef = useRef(false);
  const [showEmailConfigModal, setShowEmailConfigModal] = useState(false);
  const [todayEmployees, setTodayEmployees] = useState([]);
  const [showProposalModal, setShowProposalModal] = useState(false);
  const [proposalPdfUrl, setProposalPdfUrl] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfError, setPdfError] = useState("");
  const [showOrderDeleteDropdown, setShowOrderDeleteDropdown] = useState(false);
  const [locationEmployees, setLocationEmployees] = useState([]);
  const [leaveEvents, setLeaveEvents] = useState([]);
  const [leaveDrawerOpen, setLeaveDrawerOpen] = useState(false);
  const [selectedLeaveData, setSelectedLeaveData] = useState(null);
  const [conflictMap, setConflictMap] = useState({});
  const [recommendedEmployeeGroups, setRecommendedEmployeeGroups] = useState(null);
  const [pendingSchedulingIssues, setPendingSchedulingIssues] = useState(null);
  const recommendationRequestRef = useRef(0);
  const recommendationDebounceRef = useRef(null);
  const [proposalTemplateName, setProposalTemplateName] = useState("");
  const [isUpdatingVersion, setIsUpdatingVersion] = useState(false);
  const [showVersionBanner, setShowVersionBanner] = useState(false);
  const [viewingLatestVersion, setViewingLatestVersion] = useState(false);
  const [currentWeekDetails, setCurrentWeekDetails] = useState([]);
  const [viewedWeekDetails, setViewedWeekDetails] = useState([]);
  const skipInitialWeekFetchRef = useRef(true);
  const initialOrderWeekSetRef = useRef(false);
  const [weekDetailsLoading, setWeekDetailsLoading] = useState(false);

  const [incomingState] = useState(() => {
    if (location.state) return location.state;
    const stored = sessionStorage.getItem("pendingNavState");
    if (stored) {
      sessionStorage.removeItem("pendingNavState");
      return JSON.parse(stored);
    }
    return null;
  });

  const [activeTab, setActiveTab] = useState(incomingState?.openTab || "overview");

  useEffect(() => {
    if (incomingState?.openTab) {
      setActiveTab(incomingState.openTab);
    }
  }, [incomingState?.openTab]);

  useEffect(() => {
    if (!order) return;
    setShowVersionBanner(Boolean(order.IsOutdatedVersion));
  }, [order]);

  // Add state for today's progress data
  const [todayProgress, setTodayProgress] = useState({
    workOnSite: 0,
    tasksActive: 0,
    tasksDone: 0,
    inspections: 2 // Static as per requirement
  });

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    setShowCleanerDeleteModal(false);
  };

  const handleInventoryClick = () => {
    setActiveTab("inventery");
  };

  const handleViewAllHistory = () => {
    setActiveTab("orderhistory");
  };

  const handleViewAllTasks = () => {
    setActiveTab("planning");
  }

  const buildLeaveEvents = (unavailabilities = [], employees = [], t) => {
    if (!unavailabilities.length) return [];

    const employeeMap = employees.reduce((acc, emp) => {
      acc[emp.UserId] = emp;
      return acc;
    }, {});

    const getLeaveStyle = (type, status) => {
      const normalizedType = type?.toLowerCase();
      const normalizedStatus = status?.toLowerCase();

      if (normalizedType === "sickness") {
        return { bgClass: "leave-bg-sick", icon: "🤒", label: t("sickLeave") };
      }
      const isApproved = normalizedStatus === "approved";
      return {
        bgClass: isApproved ? "leave-bg-sick" : "leave-bg-vacation",
        icon: "🏖️",
        label: t("vacation"),
      };
    };

    const events = [];

    unavailabilities
      .filter(leave => {
        const status = leave.Status?.toLowerCase();
        return status === "approved" || status === "pending";
      })
      .forEach((leave, idx) => {
        if (!employeeMap[leave.UserId]) return;

        const { bgClass, icon, label } = getLeaveStyle(leave.Type, leave.Status);
        const endExclusive = moment(leave.EndDate).add(1, "day").format("YYYY-MM-DD");
        const startFormatted = moment(leave.StartDate).format("YYYY-MM-DD");

        events.push({
          id: `leave-bg-${idx}-${leave.UserId}`,
          title: "",
          start: startFormatted,
          end: endExclusive,
          resourceId: leave.UserId,
          display: "background",
          classNames: [bgClass],
          extendedProps: { isLeave: true, isLeaveBg: true },
        });

        events.push({
          id: `leave-badge-${idx}-${leave.UserId}`,
          title: `${icon} ${label} (${leave.Status})`,
          start: startFormatted,
          end: endExclusive,
          resourceId: leave.UserId,
          display: "auto",
          classNames: ["leave-event-transparent"],
          extendedProps: {
            isLeave: true,
            isLeaveBadge: true,
            leaveType: leave.Type?.toLowerCase(),
            leaveStatus: leave.Status,
            icon,
            label,
            leaveRawData: leave,
          },
        });
      });

    return events;
  };

  const formatStoredTime = (isoString) => {
    if (!isoString) return null;

    const timeOnly = moment.utc(isoString).format("HH:mm:ss");
    const today = moment().format("YYYY-MM-DD");

    return moment.utc(`${today}T${timeOnly}`).local().format("HH:mm");
  };

  const fetchLeaveEventsForWeek = async (weekStartDate, weekEndDate, employees) => {
    try {
      const formattedStart = moment(weekStartDate).format("YYYY-MM-DD");
      const formattedEnd = moment(weekEndDate).format("YYYY-MM-DD");
      const customerId = localStorage.getItem("customerId");
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/userUnavailabilityRoute/unavailabilityByCustomerIdWithDate`,
        {
          params: {
            customerId: customerId,
            startDate: formattedStart,
            endDate: formattedEnd,
          },
          headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
        }
      );

      const unavailabilities = Array.isArray(response.data) ? response.data : [];
      setLeaveEvents(buildLeaveEvents(unavailabilities, employees, t));
    } catch (error) {
      console.error("Error fetching leave events:", error);
      setLeaveEvents([]);
    }
  };

  const fetchEmployeesByLocation = async () => {
    const locationIdForUser = localStorage.getItem("LocationId");
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/userRoute/employeesForOrderAssignment`,
        {
          params: { locationId: locationIdForUser },
          headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
        }
      );
      const sortedEmployees = [...(res.data || [])].sort((a, b) =>
        (a.Name || "").localeCompare(b.Name || "")
      );
      setLocationEmployees(sortedEmployees);
    } catch (err) {
      console.error("Error fetching employees by location:", err);
      setLocationEmployees(allEmployees);
    }
  };

  useEffect(() => {
    if (!drawerOpen && calendarRef.current) {
      setTimeout(() => {
        calendarRef.current.getApi().updateSize();
      }, 200);
    }
  }, [drawerOpen]);

  useEffect(() => {
    if (!calendarReady) return;

    const calendarWrapper = document.querySelector('.calendar-wrapper');
    if (!calendarWrapper) return;

    const observer = new ResizeObserver(() => {
      if (calendarRef.current) {
        calendarRef.current.getApi().updateSize();
      }
    });
    observer.observe(calendarWrapper);
    return () => observer.disconnect();
  }, [calendarReady]);

  const statusBadge = (status) => {
    const statusKey = status?.toLowerCase?.();
    const translatedText = t(statusKey) || status;

    const variant =
      {
        draft: "primary",
        active: "info",
        paused: "danger",
        completed: "success",
      }[statusKey] || "secondary";

    return (
      <Badge
        bg={variant}
        className="d-inline-flex align-items-center px-2 py-1"
      >
        <span className="mb-0 fw-medium font-size-12">{translatedText}</span>
      </Badge>
    );
  };

  const fetchAndShowProposalTasks = async (proposalId, proposalVersionId) => {
    try {
      const params = proposalVersionId ? { proposalVersionId } : {};
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/proposalRoute/${proposalId}/tasksWithDetails`,
        { params, headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
      );
      const tasksWithRecurrence = (res.data || []).map((task) => ({
        ...task,
        recurrence: {
          frequency: task.Frequency,
          repeatEvery: task.RepeatEvery,
          selectedDays: (() => {
            try {
              const raw = task.SelectedDays;
              if (Array.isArray(raw)) return raw;
              if (typeof raw === "string") {
                const parsed = JSON.parse(raw);
                return Array.isArray(parsed) ? parsed : [];
              }
              return [];
            } catch { return []; }
          })(),
          monthlyDay: task.MonthlyDay,
        },
      }));
      setTaskWithSubtasks(tasksWithRecurrence);
    } catch (error) {
      console.error("Error fetching proposal tasks with details:", error);
      setTaskWithSubtasks([]);
    }
  };

  const handleUpdateOrderToNewVersion = async () => {
    setIsUpdatingVersion(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/orderRoute/${orderId}/updateWithNewProposalVersion`,
        { adminUserId: currentUserId },
        { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
      );

      toast.success(t("orderUpdatedToLatestVersion"), {
        position: "top-right",
        autoClose: 3000,
      });

      setShowVersionBanner(false);
      weekStartRef.current = weekStart;
      skipAutoWeekResetRef.current = true;
      await fetchOrderDetails();
    } catch (error) {
      console.error("Failed to update order to new proposal version:", error);
      toast.error(
        error?.response?.data?.message || t("orderVersionUpdateFailed"),
        { position: "top-right", autoClose: 4000 }
      );
    } finally {
      setIsUpdatingVersion(false);
    }
  };

  const handleViewLatestProposalVersion = async () => {
    if (!order?.ProposalId) return;

    setViewingLatestVersion(true);
    setShowProposalModal(true);
    setPdfLoading(true);
    setPdfError("");
    setProposalPdfUrl(null);
    setProposalTemplateName(order?.TemplateName || "");

    try {
      const versionedDocsRes = await axios.get(
        `${process.env.REACT_APP_API_URL}/proposalDetailsRoute/getVersionedDocuments/${order.ProposalId}`,
        { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
      );

      const versionedDocs = versionedDocsRes.data || [];
      const latestDoc =
        versionedDocs.find((d) => d.IsCurrent) ||
        [...versionedDocs].sort((a, b) => b.VersionNo - a.VersionNo)[0];

      if (latestDoc?.TemplateName) {
        setProposalTemplateName(latestDoc.TemplateName);
      }

      if (!latestDoc?.Document) {
        setPdfError(t("proposalNotAvailable"));
        setPdfLoading(false);
        return;
      }

      const blobRes = await axios.get(
        `${process.env.REACT_APP_API_URL}/blobRoute/getBlob`,
        {
          params: { blobUrl: latestDoc.Document },
          responseType: "blob",
          headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
        }
      );

      const blobUrl = URL.createObjectURL(blobRes.data);
      setProposalPdfUrl(blobUrl);
    } catch (error) {
      console.error("Failed to view latest proposal version:", error);
      setPdfError(t("proposalNotAvailable"));
    } finally {
      setPdfLoading(false);
      setViewingLatestVersion(false);
    }
  };

  // Function to calculate today's progress data
  const calculateTodayProgress = (orderData) => {
    if (!orderData?.OrderDetails) {
      setTodayProgress({
        workOnSite: 0,
        tasksActive: 0,
        tasksDone: 0,
        inspections: 2
      });
      return;
    }

    const today = moment().format("YYYY-MM-DD");

    // Filter today's order details
    const todayOrderDetails = orderData.OrderDetails.filter(detail => {
      const taskDate = moment(detail.WeekStartDate).isoWeekday(detail.DayOfWeek).format("YYYY-MM-DD");
      return taskDate === today;
    });

    // Calculate unique employees working today
    const uniqueCleanerIds = [...new Set(
      todayOrderDetails
        .filter(detail => detail.CleanerId)
        .map(detail => detail.CleanerId)
    )];
    const workOnSiteCount = uniqueCleanerIds.length;

    // Calculate tasks in progress (Status = 1)
    const tasksActiveCount = todayOrderDetails.filter(detail => {
      // Status 1 = In Progress
      return detail.Status === 1 || detail.Status === "1";
    }).length;

    // Calculate completed tasks (Status = 2)
    const tasksDoneCount = todayOrderDetails.filter(detail => {
      // Status 2 = Job Complete
      return detail.Status === 2 || detail.Status === "2";
    }).length;

    setTodayProgress({
      workOnSite: workOnSiteCount,
      tasksActive: tasksActiveCount,
      tasksDone: tasksDoneCount,
      inspections: 2 // Static value as per requirement
    });
  };

  const calculateTodayEmployees = (orderData, employeesList = allEmployees) => {

    if (!orderData?.OrderDetails) {
      setTodayEmployees([]);
      return;
    }

    const today = moment().format("YYYY-MM-DD");

    // Step 1: Check date calculation
    const todayOrderDetails = orderData.OrderDetails.filter(detail => {
      const taskDate = moment(detail.WeekStartDate)
        .isoWeekday(detail.DayOfWeek)
        .format("YYYY-MM-DD");

      return taskDate === today && detail.CleanerId;
    });

    // Step 2: Unique IDs
    const uniqueEmployeeIds = [...new Set(
      todayOrderDetails.map(d => d.CleanerId)
    )];

    // Step 3: Compare IDs
    uniqueEmployeeIds.forEach(id => {

      const match = employeesList.find(emp => {
        return emp.UserId === id;
      });
    });

    // Step 4: Build result
    const employeesWorkingToday = uniqueEmployeeIds.map(cleanerId => {

      const employee = employeesList.find(emp => emp.UserId === cleanerId);

      if (!employee) {
        return null;
      }

      const employeeTasks = todayOrderDetails.filter(
        d => d.CleanerId === cleanerId
      );

      return {
        ...employee,
        tasksCount: employeeTasks.length,
        status: employeeTasks.some(t => t.Status == 1)
          ? "online"
          : "offline"
      };
    }).filter(Boolean);
    setTodayEmployees(employeesWorkingToday);
  };

  const fetchOrderDetails = async () => {
    setLoading(true);
    try {
      const actualCurrentWeekStart = moment().startOf('isoWeek');
      const actualCurrentWeekEnd = moment().endOf('isoWeek');

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/orderRoute/${orderId}/detailsScreenData`,
        {
          params: {
            weekStart: actualCurrentWeekStart.format("YYYY-MM-DD"),
            weekEnd: actualCurrentWeekEnd.format("YYYY-MM-DD"),
          },
          headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
        }
      );

      const { order: fetchedOrder, relation, tasks, employees, weekStart: resolvedWeekStart } = res.data;

      setOrder(fetchedOrder);
      setRelationData(relation);

      const customerId = localStorage.getItem("customerId");
      fetchLeaveConflictMap(
        customerId,
        fetchedOrder.StartDate,
        fetchedOrder.EndDate || moment(fetchedOrder.StartDate).add(6, "months").format("YYYY-MM-DD")
      ).then(setConflictMap);
      setAllEmployees(employees || []);
      setEmployeeList((employees || []).filter(u => !u.IsDelete && u.Status === "0"));
      setCurrentWeekDetails(fetchedOrder.OrderDetails || []);
      setViewedWeekDetails(fetchedOrder.OrderDetails || []);
      calculateTodayEmployees({ OrderDetails: fetchedOrder.OrderDetails }, employees || []);
      calculateTodayProgress({ OrderDetails: fetchedOrder.OrderDetails });

      const tasksWithRecurrence = (tasks || []).map((task) => ({
        ...task,
        recurrence: {
          frequency: task.Frequency,
          repeatEvery: task.RepeatEvery,
          selectedDays: (() => {
            try {
              const raw = task.SelectedDays;
              if (Array.isArray(raw)) return raw;
              if (typeof raw === "string") {
                const parsed = JSON.parse(raw);
                return Array.isArray(parsed) ? parsed : [];
              }
              return [];
            } catch { return []; }
          })(),
          monthlyDay: task.MonthlyDay,
        },
      }));
      setTaskWithSubtasks(tasksWithRecurrence);

      if (!weekStartRef.current) {
        setWeekStart(
          resolvedWeekStart
            ? moment(resolvedWeekStart).startOf('isoWeek')
            : actualCurrentWeekStart
        );
      }
    } catch (err) {
      console.error("Error fetching order details:", err);
      if (!toastShownRef.current) {
        toastShownRef.current = true;
        toast.error(t("orderNotExist"), { position: "top-right", autoClose: 5000 });
        navigate("/orders");
      }
    } finally {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setLoading(false);
        });
      });
    }
  };

  const fetchWeekDetails = async (targetWeekStart) => {
    const targetWeekEnd = moment(targetWeekStart).endOf('isoWeek');
    setWeekDetailsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/orderRoute/${orderId}/detailsForWeek`,
        {
          params: {
            weekStart: moment(targetWeekStart).format("YYYY-MM-DD"),
            weekEnd: targetWeekEnd.format("YYYY-MM-DD"),
          },
          headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
        }
      );
      setViewedWeekDetails(res.data || []);
    } catch (err) {
      console.error("Error fetching week details:", err);
      setViewedWeekDetails([]);
    } finally {
      setWeekDetailsLoading(false);
    }
  };

  useEffect(() => {
    if (!weekStart) return;
    if (skipInitialWeekFetchRef.current) {
      skipInitialWeekFetchRef.current = false;
      return; // initial mount already got this week's data from fetchOrderDetails
    }
    fetchWeekDetails(weekStart);
  }, [weekStart]);

  useEffect(() => {
    if (order && allEmployees.length > 0) {
      calculateTodayEmployees(order, allEmployees);
    }
  }, [order, allEmployees]);

  const fetchRelationByNumber = async (relationId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/relationRoute/relationByNumber/${relationId}`, {
        headers: {
          Authorization: process.env.REACT_APP_BasicAuthSecret
        }
      }
      );
      setRelationData(response.data);
    } catch (error) {
      console.error("Error fetching relation data:", error);
    }
  };

  useEffect(() => {
    fetchRoleAndClaims({
      navigate,
      claimType: "orders",
      claimValue: "view",
      setHasAccess,
      setIsLoading,
    });
  }, [navigate]);

  useEffect(() => {
    fetchOrderDetails();
    fetchEmployeesByLocation();
  }, [orderId]);

  const fetchEmployeesForOrder = async (orderData) => {
    if (!orderData?.OrderDetails?.length) return;

    // Get unique cleaner IDs
    const cleanerIds = [
      ...new Set(
        orderData.OrderDetails
          .map(d => d.CleanerId)
          .filter(Boolean)
      )
    ];

    if (!cleanerIds.length) return;

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/userRoute/users/byIds`,
        { userIds: cleanerIds },
        {
          headers: {
            Authorization: process.env.REACT_APP_BasicAuthSecret
          }
        }
      );

      const users = res.data || [];
      calculateTodayEmployees(orderData, users);
      setAllEmployees(users);

      // active list for dropdowns
      setEmployeeList(
        users.filter(u => !u.IsDelete && u.Status === "0")
      );
    } catch (err) {
      console.error("Error fetching employees:", err);
    }
  };

  useEffect(() => {
    if (!order) return;

    // First time order is ever set, fetchOrderDetails already set weekStart
    // to the actual current week. Don't recompute/reset it here — only
    // honor an explicit deep-link to a specific task's week, if present.
    if (!initialOrderWeekSetRef.current) {
      initialOrderWeekSetRef.current = true;
      if (incomingState?.taskDate) {
        const taskWeek = moment(incomingState.taskDate).startOf('isoWeek');
        setWeekStart(taskWeek);
      }
      return;
    }

    if (weekStartRef.current) {
      setWeekStart(weekStartRef.current);
      weekStartRef.current = null;
      skipAutoWeekResetRef.current = false; // consumed together — avoid a stale skip on the next natural change
      return;
    }

    if (skipAutoWeekResetRef.current) {
      skipAutoWeekResetRef.current = false;
      return;
    }

    if (incomingState?.taskDate) {
      const taskWeek = moment(incomingState.taskDate).startOf('isoWeek');
      setWeekStart(taskWeek);
      return;
    }

    if (!order.StartDate || !order.EndDate) {
      setWeekStart(moment().startOf('isoWeek'));
      return;
    }

    const today = moment();
    const orderStart = moment(order.StartDate);
    const orderEnd = moment(order.EndDate);

    const initialWeek = today.isBetween(orderStart, orderEnd, 'day', '[]')
      ? today.clone().startOf('isoWeek')
      : orderStart.clone().startOf('isoWeek');

    setWeekStart(initialWeek);
  }, [order]);

  useEffect(() => {
    if (!weekStart || !allEmployees.length) return;
    const weekEnd = moment(weekStart).endOf("isoWeek");
    fetchLeaveEventsForWeek(weekStart, weekEnd, allEmployees);
  }, [weekStart, allEmployees.length]);

  useEffect(() => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(weekStart.format('YYYY-MM-DD'));
    }
  }, [weekStart]);

  useEffect(() => {
    window.handleCalendarDayClick = (isoDateStr) => {
      const date = moment(isoDateStr);
      setSelectedDateForAssign(date);
      setSelectedCleaners([]);
      setShowAssignModal(true);
    };
  }, []);

  useEffect(() => {
    const handleClick = (e) => {
      const target = e.target.closest(".plus-icon");
      if (target && target.dataset.date) {
        const isoDate = target.dataset.date;
        window.handleCalendarDayClick(isoDate);
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);
  useEffect(() => {
    if (!showAssignModal || !selectedProposalTask || !selectedDateForAssign || !locationEmployees.length) return;

    const formattedDate = selectedDateForAssign.format("YYYY-MM-DD");
    const existingEmployeeIds = [...new Set(
      (viewedWeekDetails || [])
        .filter(detail =>
          detail.OrderId === order?.OrderId &&
          detail.TaskId === selectedProposalTask.TaskId &&
          moment(detail.WeekStartDate).isoWeekday(detail.DayOfWeek).format("YYYY-MM-DD") === formattedDate
        )
        .map(detail => detail.CleanerId)
        .filter(Boolean)
    )];
    const fullEmployeeList = sortEmployeesAscending(locationEmployees);
    const customerId = localStorage.getItem("customerId");
    const startTime = order?.StartTime
      ? moment.utc(`1970-01-01T${moment.utc(order.StartTime).format("HH:mm:ss")}`).local()
      : null;
    const endTime = order?.EndTime
      ? moment.utc(`1970-01-01T${moment.utc(order.EndTime).format("HH:mm:ss")}`).local()
      : startTime?.clone().add(selectedProposalTask.DurationMinutes || 60, "minutes");

    clearTimeout(recommendationDebounceRef.current);
    const requestId = ++recommendationRequestRef.current;
    if (!existingEmployeeIds.length) {
      if (requestId === recommendationRequestRef.current) setRecommendedEmployeeGroups({ recommended: [], others: fullEmployeeList });
      return;
    }

    const availabilityArgs = {
      conflictMap,
      startDate: formattedDate,
      endDate: formattedDate,
      occurrenceDates: [moment(formattedDate)],
      timeWindow: { startTimeOfDay: startTime, endTimeOfDay: endTime },
      inFormSlots: [],
      customerId,
      excludeOrderDetailId: null,
    };

    recommendationDebounceRef.current = setTimeout(() => {
      void fetchRecommendedEmployees(customerId, existingEmployeeIds).then(async recommendations => {
        if (!recommendations) {
          if (requestId === recommendationRequestRef.current) setRecommendedEmployeeGroups({ recommended: [], others: fullEmployeeList });
          return;
        }

        const groups = await partitionRecommendedEmployees(
          fullEmployeeList,
          recommendations,
          employee => checkEmployeeAvailability({ employeeId: employee.UserId, ...availabilityArgs })
        );
        if (requestId === recommendationRequestRef.current) setRecommendedEmployeeGroups(groups);
      }).catch(() => {
        if (requestId === recommendationRequestRef.current) setRecommendedEmployeeGroups({ recommended: [], others: fullEmployeeList });
      });
    }, 275);
  }, [showAssignModal, selectedProposalTask, selectedDateForAssign, locationEmployees, viewedWeekDetails, order, conflictMap]);

  useEffect(() => {
    return () => {
      if (proposalPdfUrl) {
        URL.revokeObjectURL(proposalPdfUrl);
      }
    };
  }, [proposalPdfUrl]);

  const handleViewProposal = async () => {
    setShowProposalModal(true);
    setPdfLoading(true);
    setPdfError("");
    setProposalPdfUrl(null);
    setProposalTemplateName(order?.TemplateName || "");

    try {
      if (!order?.ProposalId) {
        setPdfError(t("proposalNotAvailable"));
        setPdfLoading(false);
        return;
      }

      // 1️ Get proposal details
      const detailsRes = await axios.get(
        `${process.env.REACT_APP_API_URL}/proposalDetailsRoute/getProposalDetailsByVersionId/${order.ProposalVersionId}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_BasicAuthSecret
          }
        }
      );

      const documentUrl = detailsRes.data?.Document;

      if (detailsRes.data?.TemplateName) {
        setProposalTemplateName(detailsRes.data.TemplateName);
      }

      if (!documentUrl) {
        setPdfError(t("proposalNotAvailable"));
        setPdfLoading(false);
        return;
      }

      // 3️ Fetch blob
      const blobRes = await axios.get(
        `${process.env.REACT_APP_API_URL}/blobRoute/getBlob`,
        {
          params: {
            blobUrl:
              documentUrl
          },
          responseType: "blob",
          headers: {
            Authorization:
              process.env.REACT_APP_BasicAuthSecret
          }
        }
      )

      const blobUrl = URL.createObjectURL(blobRes.data);
      setProposalPdfUrl(blobUrl);

    } catch (err) {
      console.error(err);
      setPdfError(t("proposalNotAvailable"));
    } finally {
      setPdfLoading(false);
    }
  };

  const renderStatusBadge = (status) => {
    const statusKey = status?.toLowerCase?.();
    const translatedText = t(statusKey) || status;

    const icon = {
      draft: faStream,
      active: faCheck,
      paused: faBan,
      completed: faCheck,
    }[statusKey];

    const variant =
      {
        draft: "primary",
        active: "info",
        paused: "danger",
        completed: "success",
      }[statusKey] || "secondary";

    return (
      <SubtleBadge
        pill
        bg={variant}
        className="d-inline-flex align-items-center px-2 py-1"
      >
        <span className="mb-0 data-font-size">{translatedText}</span>
        {icon && (
          <FontAwesomeIcon
            icon={icon}
            transform="shrink-2"
            className="ms-1 data-font-size"
          />
        )}
      </SubtleBadge>
    );
  };

  const handleEditOrderDetails = (id) => {
    navigate(`${paths.editOrder.replace(":orderId", id.toLowerCase())}`);
  };

  const startOfWeek = order?.StartDate
    ? moment(order.StartDate).startOf("isoWeek")
    : moment().startOf("isoWeek");
  const days = Array.from({ length: 7 }, (_, i) =>
    startOfWeek.clone().add(i, "days")
  );

  const tasksByDate = {};
  (order?.OrderDetails || []).forEach((task) => {
    if (!task?.WeekStartDate || !task?.DayOfWeek) return;
    const date = moment(task.WeekStartDate)
      .isoWeekday(task.DayOfWeek)
      .format("YYYY-MM-DD");
    if (!tasksByDate[date]) tasksByDate[date] = [];
    tasksByDate[date].push(task);
  });
  if (loading && !calendarReady) {
    return (
      <div className="text-center my-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">{t("loading")}</span>
        </Spinner>
      </div>
    );
  }

  const handleOrderDelete = async () => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/orderRoute/deleteOrder/${orderId}`, {
        headers: {
          Authorization: process.env.REACT_APP_BasicAuthSecret
        }
      }
      );
      toast.success(t("orderAndOrderDetailsDeletedSuccessMessage"), {
        position: "top-right",
        autoClose: 5000,
      });

      navigate("/orders");
    } catch (error) {
      console.error("Failed to delete task:", error);
      toast.error(t("orderDeleteFailedMessage"), {
        position: "top-right",
        autoClose: 5000,
      });
    }
  };

  const OrderDeleteModal = ({ show, handleClose, handleDelete }) => (
    <Modal show={show} onHide={handleClose} backdrop="static">
      <Modal.Header>
        <Modal.Title>{t("confirmation")}</Modal.Title>
        <FalconCloseButton onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>{t("confirmDeleteOrder")}</Modal.Body>
      <Modal.Footer>
        <Button variant="falcon-default" onClick={handleClose}>
          {t("cancel")}
        </Button>
        <Button variant="primary" onClick={handleDelete}>
          {t("delete")}
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const handleConfirmDeleteCleaner = async () => {
    if (!selectedOrderDetailId) return;

    try {
      weekStartRef.current = weekStart;
      skipAutoWeekResetRef.current = true;

      const targetEvent = (viewedWeekDetails || []).find(
        d => d.OrderDetailId === selectedOrderDetailId
      );

      await deleteCleanerByOrderDetailId(selectedOrderDetailId, localStorage.getItem("UserId"));
      clearEmployeeAvailabilityCache();

      toast.success(t("employeeRemovedSuccessfully"), { position: "top-right" });

      setShowCleanerDeleteModal(false);
      setSelectedOrderDetailId(null);
      setDrawerOpen(false);
      await fetchWeekDetails(weekStart);

      if (targetEvent?.CleanerId) {
        const cleaner = allEmployees.find(e => e.UserId === targetEvent.CleanerId);
        const userId = localStorage.getItem("UserId");
        const customerId = localStorage.getItem("customerId");
        const culture = localStorage.getItem("culture") || "nl";
        const taskDate = moment(targetEvent.WeekStartDate)
          .isoWeekday(targetEvent.DayOfWeek)
          .format("YYYY-MM-DD");

        const location = [
          relationData?.StreetName,
          relationData?.PostCode,
          relationData?.City,
        ].filter(Boolean).join(", ");

        const orderInfo = {
          clientName: relationData?.Name,
          location,
          startDate: taskDate,
          endDate: taskDate,
          tasks: [{
            taskName: targetEvent.TaskName || order?.TemplateName,
            startTime: targetEvent.StartTime ? moment.utc(targetEvent.StartTime).format("HH:mm") : null,
            endTime: targetEvent.EndTime ? moment.utc(targetEvent.EndTime).format("HH:mm") : null,
          }],
        };

        dispatchBatchNotification({
          customerId,
          eventKey: "TASK_UNASSIGNED",
          entries: [{
            cleaner: {
              userId: targetEvent.CleanerId,
              name: cleaner?.Name,
              email: cleaner?.Emailaddress,
              phone: cleaner?.PhoneNumber,
            },
            data: {
              orderInfo,
              culture,
              organizationName: process.env.REACT_APP_ORGANIZATION_NAME,
              userId,
              raisedFrom: userId,
              isActionRequired: false,
              sourceId: targetEvent.OrderId,
              sourceType: "order",
              sourceDate: taskDate,
              inAppMessageCleaner: t("in-AppNotifications.taskRemovedMessage", {
                taskName: targetEvent.TaskName || order?.TemplateName,
                clientName: relationData?.Name,
                date: moment(taskDate).format("DD-MM-YYYY"),
              }),
              inAppManagerSuffix: t("in-AppNotifications.orderUnassignedManagerSuffix", {
                clientName: relationData?.Name,
              }),
              useMultiTaskTemplate: true,
            }
          }]
        }
        ).catch(err => console.error("Cleaner removal notification error (non-blocking):", err));
      }

    } catch (error) {
      console.error("Failed to delete cleaner:", error);
      toast.error(t("failedToRemoveCleaner"), { position: "top-right" });
    }
  };

  const handleRemoveAllCleanersForDay = async () => {
    if (!selectedEmployeeId || !selectedTaskDate) return;

    try {
      weekStartRef.current = weekStart;
      skipAutoWeekResetRef.current = true;

      const affectedDetails = (viewedWeekDetails || []).filter(d =>
        d.CleanerId === selectedEmployeeId &&
        moment(d.WeekStartDate).isoWeekday(d.DayOfWeek).format("YYYY-MM-DD") === selectedTaskDate
      );

      await deleteAllCleanerOrderDetailsForDay(
        selectedEmployeeId,
        selectedTaskDate,
        localStorage.getItem("customerId"),
        order?.Location,
        localStorage.getItem("UserId")
      );
      clearEmployeeAvailabilityCache();

      toast.success(t("allCleanersRemovedSuccessfully"), { position: "top-right" });

      setShowCleanerDeleteModal(false);
      setSelectedOrderDetailId(null);
      setSelectedEmployeeId(null);
      setSelectedTaskDate(null);
      setDrawerOpen(false);
      await fetchWeekDetails(weekStart);

      if (affectedDetails.length > 0) {
        const userId = localStorage.getItem("UserId");
        const customerId = localStorage.getItem("customerId");
        const culture = localStorage.getItem("culture") || "nl";

        const tasksByCleaner = {};
        affectedDetails.forEach(d => {
          if (!d.CleanerId) return;
          if (!tasksByCleaner[d.CleanerId]) tasksByCleaner[d.CleanerId] = [];
          tasksByCleaner[d.CleanerId].push(d);
        });

        const location = [
          relationData?.StreetName,
          relationData?.PostCode,
          relationData?.City,
        ].filter(Boolean).join(", ");

        const entries = Object.entries(tasksByCleaner).map(([cleanerId, tasks]) => {
          const cleaner = allEmployees.find(e => e.UserId === cleanerId);

          return {
            cleaner: {
              userId: cleanerId,
              name: cleaner?.Name,
              email: cleaner?.Emailaddress,
              phone: cleaner?.PhoneNumber,
            },
            data: {
              orderInfo: {
                clientName: relationData?.Name,
                location,
                startDate: selectedTaskDate,
                endDate: selectedTaskDate,
                tasks: tasks.map(d => ({
                  taskName: d.TaskName || order?.TemplateName,
                  startTime: d.StartTime ? moment.utc(d.StartTime).format("HH:mm") : null,
                  endTime: d.EndTime ? moment.utc(d.EndTime).format("HH:mm") : null,
                })),
              },
              culture,
              organizationName: process.env.REACT_APP_ORGANIZATION_NAME,
              userId,
              raisedFrom: userId,
              isActionRequired: false,
              sourceId: tasks[0].OrderId,
              sourceType: "order",
              sourceDate: selectedTaskDate,
              inAppMessageCleaner: t("in-AppNotifications.allTasksRemovedMessage", {
                date: moment(selectedTaskDate).format("DD-MM-YYYY"),
              }),
              inAppManagerSuffix: t("in-AppNotifications.orderUnassignedManagerSuffix", {
                clientName: relationData?.Name,
              }),
              useMultiTaskTemplate: true,
            }
          };
        });

        dispatchBatchNotification({ customerId, eventKey: "TASK_UNASSIGNED", entries })
          .catch(err => console.error("Bulk removal notification error (non-blocking):", err));
      }

    } catch (error) {
      console.error("Failed to delete all cleaners:", error);
      toast.error(t("failedToRemoveCleaner"), { position: "top-right" });
    }
  };

  // UPDATED: Now accepts an object with orderDetailId, employeeId, and taskDate
  const openCleanerDeleteModal = (data) => {
    setSelectedOrderDetailId(data.orderDetailId);
    setSelectedEmployeeId(data.employeeId);
    setSelectedTaskDate(data.taskDate);
    setShowCleanerDeleteModal(true);
  };

  const buildSchedulingIssues = (conflictResult, employeeId, employeeName, date) => {
    const rawIssues = conflictResult?.type === "combined"
      ? conflictResult.issues
      : conflictResult?.type
        ? [conflictResult]
        : [];
    const issues = rawIssues.map(issue => ({
      type: issue.type,
      employeeId,
      employeeName,
      leaveType: issue.leaveType,
      leaveStatus: issue.leaveStatus,
      conflictTaskName: issue.conflictTaskName,
      conflictClientName: issue.conflictClientName,
      conflictStart: issue.conflictStart,
      conflictEnd: issue.conflictEnd,
    }));

    if (moment(date).isBefore(moment(), "day")) {
      issues.push({ type: "pastDateAssign", employeeId, employeeName });
    }
    return issues;
  };

  const getAssignmentTimeWindow = () => {
    const startTimeOfDay = order?.StartTime
      ? moment.utc(`1970-01-01T${moment.utc(order.StartTime).format("HH:mm:ss")}`).local()
      : null;
    const endTimeOfDay = order?.EndTime
      ? moment.utc(`1970-01-01T${moment.utc(order.EndTime).format("HH:mm:ss")}`).local()
      : startTimeOfDay?.clone().add(selectedProposalTask?.DurationMinutes || 60, "minutes");
    return { startTimeOfDay, endTimeOfDay };
  };

  const handleAddCleanersForDay = async (cleanersList = selectedCleaners, closeModal = false) => {
    if (!selectedProposalTask) {
      toast.error(t("pleaseSelectTaskFirst"), { position: "top-right", autoClose: 5000 });
      return;
    }

    const previouslyAssigned = selectedCleaners;
    const newlyAdded = cleanersList.find((id) => !previouslyAssigned.includes(id));

    if (!newlyAdded) {
      setSelectedCleaners(cleanersList);
      if (closeModal) await proceedAddCleaners(cleanersList);
      return;
    }

    const formattedDate = selectedDateForAssign.clone().format("YYYY-MM-DD");

    const inViewSlots = (viewedWeekDetails || [])
      .filter((d) => moment(d.WeekStartDate).isoWeekday(d.DayOfWeek).format("YYYY-MM-DD") === formattedDate)
      .map((d) => ({
        id: d.OrderDetailId,
        employeeId: d.CleanerId,
        start: combineDateAndTimeOfDay(formattedDate, d.StartTime),
        end: combineDateAndTimeOfDay(formattedDate, d.EndTime),
        label: d.TaskName || order?.TemplateName,
        clientName: relationData?.Name,
        dayKey: moment(formattedDate).format("dddd").toLowerCase(),
        date: formattedDate,
      }))
      .filter((s) => s.start && s.end);

    const { startTimeOfDay, endTimeOfDay } = getAssignmentTimeWindow();
    let conflictResult = null;

    conflictResult = await checkEmployeeAvailability({
      employeeId: newlyAdded,
      conflictMap,
      startDate: formattedDate,
      endDate: formattedDate,
      occurrenceDates: [moment(formattedDate)],
      timeWindow: { startTimeOfDay, endTimeOfDay },
      inFormSlots: inViewSlots,
      customerId: localStorage.getItem("customerId"),
      excludeOrderDetailId: null,
    });

    const employeeName = locationEmployees.find((e) => e.UserId === newlyAdded)?.Name || newlyAdded;
    const issues = buildSchedulingIssues(conflictResult, newlyAdded, employeeName, formattedDate);

    if (issues.length) {
      setPendingSchedulingIssues({ issues, cleanersList, closeModal });
      return;
    }

    setSelectedCleaners(cleanersList);
    if (closeModal) await proceedAddCleaners(cleanersList);
  };

  const proceedAddCleaners = async (cleanersToAdd = selectedCleaners) => {
    setIsAssigning(true);

    const dayDate = selectedDateForAssign.clone();
    const formattedDate = dayDate.format("YYYY-MM-DD");
    const dayOfWeek = dayDate.format("dddd").toLowerCase();

    if (!selectedProposalTask.recurrence?.selectedDays?.includes(dayOfWeek)) {
      toast.error(t("noTaskScheduledForThisDay"), { position: "top-right", autoClose: 5000 });
      resetModalState();
      return;
    }

    const newDetails = [];
    let cleanerAlreadyAssignedCount = 0;

    cleanersToAdd.forEach((cleanerId) => {
      const alreadyExists = (viewedWeekDetails || []).some(
        (detail) =>
          detail.OrderId === order.OrderId &&
          detail.CleanerId === cleanerId &&
          detail.TaskId === selectedProposalTask.TaskId &&
          moment(detail.WeekStartDate).isSame(formattedDate, "day")
      );

      if (alreadyExists) {
        cleanerAlreadyAssignedCount++;
      } else {
        const startTime = order?.StartTime ? moment(order.StartTime) : null;
        const endTime = order?.EndTime
          ? moment(order.EndTime)
          : startTime ? moment(startTime).add(1, "hour") : null;

        newDetails.push({
          OrderDetailId: uuidv4(),
          OrderId: order.OrderId,
          TaskId: selectedProposalTask.TaskId,
          ProposalTaskId: selectedProposalTask.ProposalTaskId,
          WeekStartDate: formattedDate,
          DayOfWeek: dayOfWeek,
          StartTime: startTime ? startTime.toISOString() : null,
          EndTime: endTime ? endTime.toISOString() : null,
          DurationMinutes: selectedProposalTask.DurationMinutes || 60,
          CleanerId: cleanerId,
          Status: "Planned",
          Location: null,
          Notes: "",
        });
      }
    });

    if (newDetails.length === 0 && cleanerAlreadyAssignedCount > 0) {
      toast.error(t("allEmployeeAlreadyAssigned"), { position: "top-right", autoClose: 5000 });
      resetModalState();
      return;
    }

    try {
      weekStartRef.current = weekStart;

      await axios.post(`${process.env.REACT_APP_API_URL}/orderRoute/createOrderDetails`, {
        details: newDetails,
        performedBy: localStorage.getItem("UserId"),
      }, {
        headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
      });
      clearEmployeeAvailabilityCache();

      const userId = localStorage.getItem("UserId");
      const customerId = localStorage.getItem("customerId");
      const culture = localStorage.getItem("culture") || "nl";
      const task = taskWithSubtasks.find(t => t.ProposalTaskId === selectedProposalTask.ProposalTaskId);

      const location = [
        relationData?.StreetName,
        relationData?.HouseNumber,
        relationData?.PostCode,
        relationData?.City,
      ].filter(Boolean).join(", ");

      const entries = newDetails
        .map(detail => {
          const cleaner = allEmployees.find(c => c.UserId === detail.CleanerId);
          if (!cleaner) return null;

          return {
            cleaner: {
              userId: cleaner.UserId,
              name: cleaner.Name,
              email: cleaner.Emailaddress,
              phone: cleaner.PhoneNumber,
            },
            data: {
              orderInfo: {
                clientName: relationData?.Name,
                location,
                startDate: detail.WeekStartDate,
                endDate: detail.WeekStartDate,
                tasks: [{
                  taskName: task?.taskName,
                  startTime: detail.StartTime ? moment(detail.StartTime).format("HH:mm") : null,
                  endTime: detail.EndTime ? moment(detail.EndTime).format("HH:mm") : null,
                }],
              },
              culture,
              organizationName: process.env.REACT_APP_ORGANIZATION_NAME,
              userId,
              raisedFrom: userId,
              isActionRequired: true,
              sourceId: orderId,
              sourceType: "order",
              sourceDate: detail.WeekStartDate,
              inAppMessageCleaner: t("in-AppNotifications.taskAssignedMessage", {
                taskName: task?.taskName,
                clientName: relationData?.Name,
              }),
              inAppManagerSuffix: t("in-AppNotifications.taskAssignedManagerSuffix", {
                taskName: task?.taskName,
                clientName: relationData?.Name,
              }),
              whatsappTemplateName: `task_notification_marketing_${culture}`,
              whatsappParameters: [
                cleaner.Name,
                task?.taskName,
                `${moment(detail.WeekStartDate).format("DD-MM-YYYY")} ${detail.StartTime ? moment(detail.StartTime).format("HH:mm") : ""}`,
                location,
              ],
            }
          };
        })
        .filter(Boolean);

      toast.success(t("employeeAssignedSuccess"), { position: "top-right", autoClose: 5000 });

      resetModalState();
      await fetchWeekDetails(weekStart);
      dispatchBatchNotification({ customerId, eventKey: "TASK_ASSIGNED", entries })
        .catch(err => console.error("Assignment notification error (non-blocking):", err));
    } catch (err) {
      console.error("Failed to add cleaner:", err);
      toast.error(t("errorAssigningCleaner"), { position: "top-right", autoClose: 5000 });
    } finally {
      setIsAssigning(false);
    }
  };

  const resetModalState = () => {
    setShowAssignModal(false);
    setSelectedCleaners([]);
    setSelectedDateForAssign(null);
    setSelectedProposalTask(null);
  };

  const loadingOrRedirect = handleLoadingAndAccess(
    isLoading,
    hasAccess,
  );

  if (loadingOrRedirect) {
    return loadingOrRedirect; // Render the loading spinner or handle navigation
  }

  // calender
  const renderEmployeeOverviewCalendar = () => {
    if (!order) return null;

    const currentWeekStart = moment(weekStart).startOf('isoWeek');
    const currentWeekEnd = currentWeekStart.clone().endOf('isoWeek');

    const filteredOrderDetails = viewedWeekDetails;

    const cleanerIdsWithTasks = [...new Set(filteredOrderDetails.map(d => d.CleanerId))];
    const filteredEmployees = allEmployees.filter(emp => cleanerIdsWithTasks.includes(emp.UserId));

    const workedMinutesMap = {};
    filteredOrderDetails.forEach(detail => {
      const cleanerId = detail.CleanerId;
      const duration = detail.DurationMinutes || 0;
      if (cleanerId) {
        workedMinutesMap[cleanerId] = (workedMinutesMap[cleanerId] || 0) + duration;
      }
    });

    const buildResources = () =>
      filteredEmployees.map(emp => {
        const workedMinutes = workedMinutesMap[emp.UserId] || 0;
        const hours = Math.floor(workedMinutes / 60);
        const minutes = workedMinutes % 60;
        const formattedWorked = `${hours}${t("hours")}${minutes}`;

        return {
          id: emp.UserId,
          title: emp.Name,
          extendedProps: {
            expectedHours: emp.FixedHours || 40,
            workedDisplay: formattedWorked
          }
        };
      });

    const getStatusColorClass = (status) => {
      let normalizedStatus = "";
      if (status === null || status === undefined) {
        normalizedStatus = "";
      } else if (!isNaN(Number(status))) {
        switch (Number(status)) {
          case 0: normalizedStatus = "planned"; break;
          case 1: normalizedStatus = "inprogress"; break;
          case 2: normalizedStatus = "jobcomplete"; break;
          case 3: normalizedStatus = "unabletoaccesslocation"; break;
          case 4: normalizedStatus = "customernotavailable"; break;
          case 5: normalizedStatus = "equipmentissue"; break;
          case 6: normalizedStatus = "cancelledbycustomer"; break;
          case 7: normalizedStatus = "incomplete"; break;
          default: normalizedStatus = ""; break;
        }
      } else {
        normalizedStatus = status.toString().replace(/\s+/g, "").toLowerCase();
      }
      switch (normalizedStatus) {
        case "planned": return "bg-primary-subtle text-primary";
        case "inprogress": return "bg-info-subtle text-info";
        case "jobcomplete": return "bg-success-subtle text-success";
        case "unabletoaccesslocation":
        case "customernotavailable":
        case "equipmentissue": return "bg-warning-subtle text-secondary";
        case "cancelledbycustomer": return "bg-danger-subtle text-danger";
        case "incomplete": return "bg-warning-subtle text-warning";
        default: return "bg-light text-dark";
      }
    };

    const buildEvents = () =>
      filteredOrderDetails.map(detail => {
        const taskDate = moment(detail.WeekStartDate).isoWeekday(detail.DayOfWeek).format('YYYY-MM-DD');

        const startMomentUtc = moment.utc(detail.StartTime);
        const timeOnly = startMomentUtc.format("HH:mm:ss");
        const start = moment.utc(`${taskDate}T${timeOnly}`, "YYYY-MM-DDTHH:mm:ss").local();
        const end = start.clone().add(detail.DurationMinutes || 60, 'minutes');

        let computedDuration = detail.DurationMinutes || 60;
        if (detail.StartTime && detail.EndTime) {
          const dateStr = moment(detail.WeekStartDate).format("YYYY-MM-DD");
          const startLocalTime = moment.utc(detail.StartTime).local();
          const endLocalTime = moment.utc(detail.EndTime).local();

          const plannedStart = moment(
            `${dateStr}T${startLocalTime.format("HH:mm")}`,
            "YYYY-MM-DDTHH:mm"
          );
          const plannedEnd = moment(
            `${dateStr}T${endLocalTime.format("HH:mm")}`,
            "YYYY-MM-DDTHH:mm"
          );

          computedDuration = plannedEnd.diff(plannedStart, "minutes");
        }

        return {
          id: detail.OrderDetailId,
          title: relationData?.Name || "Client",
          start: start.toDate(),
          end: end.toDate(),
          resourceId: detail.CleanerId,
          extendedProps: {
            rawData: { ...detail, DurationMinutes: computedDuration },
            workType: order?.WorkType,
            taskName: detail.TaskName
          }
        };
      });

    const formatShortHours = (minutes) => {
      if (!minutes || isNaN(minutes)) return null;

      const totalMinutes = Math.floor(minutes);
      const hrs = Math.floor(totalMinutes / 60);
      const mins = totalMinutes % 60;

      return `${hrs}${t("hourUnit")}${mins.toString().padStart(2, '0')}`;
    };

    const isPrevDisabled = moment(weekStart).isSame(moment(order.StartDate).startOf('isoWeek'), 'day');

    const isNextDisabled =
      !order.LastPlannedWeekStartDate ||
      moment(weekStart).isSameOrAfter(moment(order.LastPlannedWeekStartDate).startOf('isoWeek'), 'day');

    const headerDate = moment(weekStart);

    const isEmptyWeek = filteredEmployees.length === 0 || buildResources().length === 0;

    const calendarResources = isEmptyWeek
      ? [{ id: 'no-employee', title: t('noTasksAssignedForThisWeek'), extendedProps: { isPlaceholder: true } }]
      : buildResources();

    return (
      <div className="position-relative">
        <Card className="mb-0 shadow-none">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h3 className="mb-0 fw-medium font-size-15">
              {`${t(`months.${headerDate.format("MMMM").toLowerCase()}`)} ${headerDate.format("YYYY")}`}
              <span className="ms-2 text-muted">({t("week")} {headerDate.isoWeek()})</span>
            </h3>
            <div className="d-flex justify-content-center justify-content-md-start mt-2 mt-md-0">
              <IconButton
                icon="chevron-left"
                variant="outline-primary"
                size="sm"
                className="me-2"
                onClick={() => setWeekStart(moment(weekStart).subtract(7, "days"))}
                disabled={isPrevDisabled || weekDetailsLoading}
              />
              <IconButton
                icon="chevron-right"
                variant="outline-primary"
                size="sm"
                onClick={() => setWeekStart(moment(weekStart).add(7, "days"))}
                disabled={isNextDisabled || weekDetailsLoading}
              />
            </div>
          </Card.Header>

          <Card.Body className="p-0">
            <FullCalendar
              ref={calendarRef}
              eventDidMount={() => setCalendarReady(true)}
              datesSet={() => setCalendarReady(true)}
              initialDate={weekStart.toDate()}
              plugins={[resourceTimelinePlugin, interactionPlugin]}
              initialView="resourceTimelineWeek"
              schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
              timeZone="local"
              headerToolbar={false}
              firstDay={1}
              resourceAreaWidth="160px"
              resourceOrder="title"
              resources={calendarResources || []}
              events={[...(buildEvents() || []), ...leaveEvents]}
              slotMinTime="00:00:00"
              slotMaxTime="24:00:00"
              slotDuration={{ days: 1 }}
              allDaySlot={false}
              nowIndicator={false}
              selectable={false}
              editable={false}
              height="auto"
              views={{
                resourceTimelineWeek: {
                  type: 'resourceTimeline',
                  duration: { weeks: 1 },
                  slotDuration: { days: 1 },
                  slotLabelContent: function (arg) {
                    const date = moment(arg.date);
                    const dayNumber = date.date();
                    const month = date.month() + 1;
                    const weekdayKey = date.format("dddd").toLowerCase();
                    const translatedDay = t(`days.${weekdayKey}`);
                    const isPastDate = date.isBefore(moment(), "day");
                    const isTaskScheduledForDay = taskWithSubtasks.some(
                      (task) => task.recurrence?.selectedDays?.includes(weekdayKey)
                    );
                    const shouldShowHover = isTaskScheduledForDay && !isPastDate;

                    return {
                      html: `
                        <div class="rounded-date-wrapper">
                          <div class="date-circle ${shouldShowHover ? "has-task" : "no-hover"}">
                            <span class="date-number">${translatedDay} ${dayNumber}/${month}</span>
                            ${shouldShowHover
                          ? `<button class="plus-icon" type="button" data-date="${date.format("YYYY-MM-DD")}">
                                   <i class="fa fa-plus" aria-hidden="true"></i>
                                 </button>`
                          : ""
                        }
                          </div>
                        </div>
                      `,
                    };
                  }
                }
              }}
              resourceAreaColumns={[{
                field: 'title',
                headerContent: t("employee"),
                isMain: true,
                cellContent: function (arg) {
                  const { title, extendedProps } = arg.resource || {};
                  const workedDisplay = extendedProps?.workedDisplay || "";
                  const expected = extendedProps?.expectedHours || "";
                  const displayText = title || t("noTasksAssignedForThisWeek");

                  const badgeHtml = workedDisplay
                    ? ReactDOMServer.renderToStaticMarkup(
                      <SubtleBadge pill bg="primary" className="mt-1 sm fs-12">
                        {workedDisplay} / {expected}{t("hourUnit")}
                      </SubtleBadge>
                    )
                    : '';

                  return {
                    html: `
                      <div class="fc-resource-name-wrapper d-flex flex-column text-wrap text-break white-space-normal">
                        <div class="calender-text fw-semibold" style="white-space: normal; word-break: break-word;">
                          ${displayText}
                        </div>
                        ${badgeHtml}
                      </div>
                    `
                  };
                }
              }]}

              eventClick={(info) => {
                if (info.event.extendedProps?.isLeave && info.event.extendedProps?.isLeaveBadge) {
                  const leave = info.event.extendedProps?.leaveRawData;
                  if (leave) {
                    const employee = allEmployees.find(
                      (emp) => emp.UserId === (leave.UserId || leave.userId)
                    );
                    setSelectedLeaveData({
                      UnavailabilityId: leave.UnavailabilityId || leave.unavailabilityId,
                      Type: leave.Type || leave.type,
                      Status: leave.Status || leave.status,
                      StartDate: leave.StartDate || leave.startDate,
                      EndDate: leave.EndDate || leave.endDate,
                      StartTime: leave.StartTime || leave.startTime,
                      EndTime: leave.EndTime || leave.endTime,
                      Notes: leave.Notes || leave.notes,
                      AdminNote: leave.AdminNote || leave.adminNote,
                      userName: employee?.Name || '--',
                      avatarColor: 'bg-primary-subtle text-primary-emphasis',
                      decisionByName: leave.decisionByName || leave.DecisionByName,
                      updatedAt: leave.updatedAt || leave.UpdatedAt,
                      UserId: leave.UserId || leave.userId,
                    });
                    setLeaveDrawerOpen(true);
                  }
                  return;
                }


                const rawData = info.event.extendedProps?.rawData;
                if (!rawData) return;
                const taskId = rawData.TaskId;
                const cleanerId = rawData.CleanerId;

                weekStartRef.current = weekStart;
                setDetailsLoading(true);
                setSelectedTask(null);
                setDrawerOpen(true);

                const matchingTask = taskWithSubtasks.find(task => task.TaskId === taskId);
                const subtasks = matchingTask?.Subtasks || [];
                const cleaner = allEmployees.find(emp => emp.UserId === cleanerId);

                const enrichedTask = {
                  ...rawData,
                  Relation: relationData || null,
                  WorkType: order?.WorkType || null,
                  TemplateName: order?.TemplateName || null,
                  Cleaner: cleaner || null,
                  Subtasks: subtasks,
                  ProposalId: order?.ProposalId || rawData?.ProposalId || null,
                  Order: { Location: order?.Location || null, ProposalId: order?.ProposalId || null },
                };

                const isCompleted = Number(rawData.Status) === 2;

                if (isCompleted) {
                  axios.get(
                    `${process.env.REACT_APP_API_URL}/orderRoute/orderDetail/${rawData.OrderDetailId}/signature`,
                    { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
                  ).then((res) => {
                    setSelectedTask((prev) =>
                      prev && prev.OrderDetailId === rawData.OrderDetailId
                        ? { ...prev, ClientSignature: res.data?.ClientSignature || null }
                        : prev
                    );
                  }).catch((err) => {
                    console.error("Failed to fetch signature:", err);
                  });
                }

                setTimeout(() => {
                  setSelectedTask(enrichedTask);
                  setDetailsLoading(false);
                }, 200);
              }}

              eventClassNames={(arg) => {
                if (arg.event.extendedProps?.isLeave) {
                  if (arg.event.extendedProps?.isLeaveBg) return [];
                  return ["leave-event-transparent"];
                }
                return ["fc-event-white-outline"];
              }}

              eventContent={(arg) => {
                if (arg.event.extendedProps?.isLeave) {
                  if (arg.event.extendedProps?.isLeaveBg) return null;

                  const { icon, leaveStatus, leaveType } = arg.event.extendedProps;
                  const label = leaveType === "sickness" ? t("sickLeave") : t("vacation");
                  const translatedStatus = t(`leaveStatus.${leaveStatus?.toLowerCase()}`) || leaveStatus;
                  const isSick = leaveType === "sickness";
                  const isApprovedVacation = leaveType === "vacation" && leaveStatus?.toLowerCase() === "approved";
                  const isPending = leaveStatus?.toLowerCase() === "pending";
                  const isRedPill = isSick || isApprovedVacation;
                  const pillBg = isRedPill ? "bg-danger" : "";
                  const pillText = isRedPill ? "text-white" : "text-warning-emphasis";
                  const pillBorder = isPending
                    ? "leave-pill-border-pending"
                    : isRedPill ? "" : "leave-pill-border-vacation";

                  return (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id={`leave-tooltip-${arg.event.id}`}>
                          {icon} {label} ({translatedStatus})
                        </Tooltip>
                      }
                    >
                      <div
                        className={`d-inline-flex align-items-center gap-1 rounded w-100 overflow-hidden leave-pill cursor-pointer ${pillBg} ${pillBorder}`}
                        style={!isRedPill ? { backgroundColor: "rgba(255, 193, 7, 0.18)" } : {}}
                      >
                        <span className="fs-12">{icon}</span>
                        <span className={`fs-12 fw-medium ${pillText}`}>{label}</span>
                        <span className={`fs-12 fw-normal opacity-75 ${pillText}`}>({translatedStatus})</span>
                      </div>
                    </OverlayTrigger>
                  );
                }

                const { rawData } = arg.event.extendedProps || {};
                const { StartTime, ActualStartTime, Status, WeekStartDate, DayOfWeek, DurationMinutes } = rawData || {};

                const formattedDuration = formatShortHours(DurationMinutes);
                const taskDate = moment(WeekStartDate).isoWeekday(DayOfWeek).format("YYYY-MM-DD");

                let timeFormatted = null;
                if (StartTime) {
                  const timeOnly = moment.utc(StartTime).format("HH:mm:ss");
                  const combined = moment.utc(`${taskDate}T${timeOnly}`, "YYYY-MM-DDTHH:mm:ss").local();
                  timeFormatted = combined.format("HH:mm");
                }

                let startedLate = false;
                if (StartTime && ActualStartTime) {
                  const scheduled = moment.utc(`${taskDate}T${moment.utc(StartTime).format("HH:mm:ss")}`).local();
                  const actual = moment.utc(`${taskDate}T${moment.utc(ActualStartTime).format("HH:mm:ss")}`).local();
                  startedLate = actual.isAfter(scheduled);
                }

                const isCompleted = Number(Status) === 2;

                // ── Rich card classes from orderDetail Status ──
                const detailStatus = String(Status ?? "0").toLowerCase();

                const cardBgBorderClass = (() => {
                  if (detailStatus === "2" || detailStatus === "jobcomplete" || detailStatus === "completed") return "border-success bg-success-subtle text-success";
                  if (detailStatus === "1" || detailStatus === "inprogress" || detailStatus === "active") return "border-success bg-success-subtle text-success";
                  if (detailStatus === "6" || detailStatus === "cancelledbycustomer" || detailStatus === "cancelled") return "border-danger bg-danger-subtle text-danger";
                  if (detailStatus === "7" || detailStatus === "incomplete") return "border-warning bg-warning-subtle text-warning";
                  return "border-primary bg-primary-subtle text-primary";
                })();

                const subtleClass = (() => {
                  if (detailStatus === "2" || detailStatus === "jobcomplete" || detailStatus === "completed") return "bg-success-subtle text-success border border-success border-opacity-10";
                  if (detailStatus === "1" || detailStatus === "inprogress" || detailStatus === "active") return "bg-success-subtle text-success border border-success border-opacity-10";
                  if (detailStatus === "6" || detailStatus === "cancelledbycustomer" || detailStatus === "cancelled") return "bg-danger-subtle text-danger border border-danger border-opacity-10";
                  if (detailStatus === "7" || detailStatus === "incomplete") return "bg-warning-subtle text-warning border border-warning border-opacity-10";
                  return "bg-primary-subtle text-primary border border-primary border-opacity-10";
                })();

                const statusLabel = (() => {
                  if (detailStatus === "2" || detailStatus === "jobcomplete" || detailStatus === "completed") return t("completed");
                  if (detailStatus === "1" || detailStatus === "inprogress" || detailStatus === "active") return t("active");
                  if (detailStatus === "6" || detailStatus === "cancelledbycustomer" || detailStatus === "cancelled") return t("cancelled");
                  if (detailStatus === "7" || detailStatus === "incomplete") return t("incomplete");
                  return t("planned");
                })();

                const locationText = [relationData?.StreetName, relationData?.City]
                  .filter((v) => v && v.trim() !== "")
                  .join(", ");

                const timeLabel = timeFormatted
                  ? formattedDuration
                    ? `${timeFormatted} (${formattedDuration})`
                    : timeFormatted
                  : "";

                return (
                  <div className={`position-relative border-start border-3 ${cardBgBorderClass} rounded-2 px-2 py-2`}>

                    {/* Remove button: top-right, visible on hover */}
                    {!isCompleted && (
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id={`remove-tooltip-${arg.event.id}`}>{t("removeEmployee")}</Tooltip>}
                      >
                        <span
                          className="remove-employee-btn cursor-pointer text-danger lh-1"
                          style={{ position: "absolute", top: 2, right: 4, zIndex: 6 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            const raw = arg.event.extendedProps?.rawData;
                            openCleanerDeleteModal({
                              orderDetailId: raw?.OrderDetailId,
                              employeeId: raw?.CleanerId,
                              taskDate: raw?.WeekStartDate
                            });
                          }}
                        >
                          <i className="fas fa-times-circle fs-11" />
                        </span>
                      </OverlayTrigger>
                    )}

                    {/* Row 1: exclamation icon + client name */}
                    <div className="d-flex align-items-center gap-1 mb-1">
                      {startedLate && (
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id={`late-tooltip-${arg.event.id}`}>{t("jobStartedLate")}</Tooltip>}
                        >
                          <FontAwesomeIcon
                            icon={faExclamationCircle}
                            className="text-warning cursor-pointer flex-shrink-0"
                            style={{ fontSize: "11px" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              toast.warning(t("jobStartedLate"), { position: "top-right" });
                            }}
                          />
                        </OverlayTrigger>
                      )}
                      <div className="fw-semibold text-dark fs-12 text-truncate flex-grow-1">
                        {relationData?.Name || t("client")}
                      </div>
                    </div>

                    {/* Row 2: status badge */}
                    <div className="mb-1">
                      <span className={`badge fs-14 rounded-pill d-inline-block mw-100 text-truncate ${subtleClass}`}>
                        {statusLabel}
                      </span>
                    </div>

                    {/* Row 3: location */}
                    {locationText && (
                      <div className="text-muted fs-11 mb-1 d-flex align-items-start gap-1">
                        <i className="fas fa-map-marker-alt text-500 flex-shrink-0 calendar-icon"></i>
                        <span className="flex-grow-1 text-break calendar-event-location">{locationText}</span>
                      </div>
                    )}

                    {/* Row 4: time */}
                    {timeLabel && (
                      <div className="text-muted fs-11 d-flex align-items-start gap-1">
                        <i className="fas fa-clock text-500 flex-shrink-0 calendar-icon"></i>
                        <span className="text-dark">{timeLabel}</span>
                      </div>
                    )}
                  </div>
                );
              }}
            />
          </Card.Body>
        </Card>
      </div>
    );
  };

  const relationMap = {};
  if (relationData?.RelationId) {
    relationMap[relationData.RelationId] = relationData;
  }

  const cleanerMap = allEmployees.reduce((acc, user) => {
    acc[user.UserId] = user;
    return acc;
  }, {});

  if (!order || !weekStart) return null;

  const orderLocation = [
    relationData?.StreetName,
    relationData?.PostCode,
    relationData?.City,
  ].filter(Boolean).join(", ");

  const getTaskDate = (detail) => {
    return moment(detail.WeekStartDate)
      .isoWeekday(detail.DayOfWeek)
      .startOf("day");
  };

  const today = moment().startOf("day");

  const todayTasks = currentWeekDetails.filter(detail =>
    getTaskDate(detail).isSame(today, "day")
  );

  const weekTasks = currentWeekDetails.filter(detail =>
    getTaskDate(detail).isSame(moment(), "isoWeek")
  );

  return (
    <>
      <Card className="mb-3 h-100 shadow-none border">
        <Background image={corner4} className="bg-card" />
        <Card.Body className="position-relative pe-3 pb-2">
          <Row className="align-items-start align-items-md-center mb-1">
            <Col xs={12} md className="flex-grow-1 min-w-0">
              <div className="order-header-info">
                {/* Breadcrumbs - visible on all devices */}
                <div>
                  <Breadcrumb className="mb-0">
                    <Breadcrumb.Item
                      as={Link}
                      to="/orders"
                      className="fw-semi-bold mt-1 font-size-12 data-font-colour"
                      active
                    >
                      <span className="fw-normal font-size-12 text-muted ">
                        {t("orders")}
                      </span>

                    </Breadcrumb.Item>

                    <Breadcrumb.Item
                      className="fw-bold mb-1 fs-9 data-font-colour"
                      active
                    >
                      <span className="order-badge badge rounded-3 border border-400 text-muted px-2 fw-normal font-size-12">
                        {order?.OrderNumber || "01501261659314"}
                      </span>
                    </Breadcrumb.Item>
                  </Breadcrumb>
                </div>
                <div className="d-flex align-items-center gap-2 header-title-row">
                  <h1 className="mb-0 order-title">
                    {order?.ClientName}
                  </h1>
                  {statusBadge(order?.Status)}
                </div>

                <div className="text-secondary order-subtitle min-w-0">
                  <span className="mb-0 template-name flex-shrink-0">
                    {order?.TemplateName}
                  </span>
                  <p className="mb-0 location-info" title={orderLocation}>
                    <i className="fas fa-map-marker-alt me-1 flex-shrink-0"></i>
                    <span className="location-text text-truncate">
                      {orderLocation}
                    </span>
                  </p>
                </div>
              </div>
            </Col>

            <Col xs={12} md="auto" className="order-actions-col flex-shrink-0">
              <div className="d-flex flex-wrap flex-md-nowrap align-items-center order-actions-wrapper">
                <Button
                  size="sm"
                  variant="falcon-default"
                  className="rounded-3 shadow-none bg-transparent border-secondary action-btn view-proposal-btn"
                  onClick={handleViewProposal}
                >
                  <i className="far fa-file-alt me-1" />
                  {t("viewProposal")}
                </Button>

                <Button
                  size="sm"
                  variant="falcon-default"
                  className="rounded-3 border-secondary shadow-none bg-transparent action-btn assign-btn"
                >
                  <i className="far fa-user me-1" />
                  {t("assign")}
                </Button>

                <Button
                  size="sm"
                  variant="falcon-default"
                  className="rounded-3 shadow-none bg-primary text-white action-btn edit-btn"
                  onClick={() => handleEditOrderDetails(orderId)}
                >
                  <i className="fas fa-pencil-alt me-1" />
                  {t("editOrder")}
                </Button>
                <div className="navbar p-0">
                  <Dropdown navbar={true}>
                    <Dropdown.Toggle
                      bsPrefix="toggle"
                      as="span"
                      role="button"
                      className="pe-0 ps-1 nav-link pe-3 cursor-pointer"
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fas fa-ellipsis-h" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="dropdown-caret dropdown-menu-card dropdown-menu-end mt-1 ps-3">
                      <div className="bg-white rounded-2 py-1 dark__bg-1000">
                        <Dropdown.Item
                          onClick={() => setShowOrderDeleteModal(true)}
                          className="text-danger"
                        >
                          <i className="fas fa-trash-alt me-2" />
                          {t("delete")}
                        </Dropdown.Item>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Collapse in={showVersionBanner} appear unmountOnExit>
        <div>
          <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-2 rounded-3 border border-warning-subtle bg-warning-subtle px-3 py-2 mb-3 position-relative">
            <div className="d-flex align-items-center gap-2">
              <i className="fas fa-exclamation-triangle text-warning" />
              <span className="fs-13 text-dark mb-0">{t("proposalVersionUpdateMessage")}</span>
            </div>
            <div className="d-flex align-items-center gap-2">
              <Button
                size="sm"
                variant="falcon-default"
                disabled={viewingLatestVersion}
                onClick={handleViewLatestProposalVersion}
              >
                {viewingLatestVersion ? t("loading") : t("viewLatestVersion")}
              </Button>
              <Button
                size="sm"
                variant="primary"
                disabled={isUpdatingVersion}
                onClick={handleUpdateOrderToNewVersion}
              >
                {isUpdatingVersion ? t("saving") : t("updateOrder")}
              </Button>
              <span
                className="cursor-pointer  ms-1 fs-9"
                onClick={() => setShowVersionBanner(false)}
              >
                <i className="fas fa-times" />
              </span>
            </div>
          </div>
        </div>
      </Collapse>

      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">{t("loading")}</span>
          </Spinner>
        </div>
      ) : (
        <Col lg={12}>
          <Card style={{ padding: "17px" }}>
            <Row className="align-items-center gy-3 mb-3">
              <Col md={4} className="d-flex align-items-center">
                <div className="d-flex align-items-center gap-3 w-100">
                  <div className="d-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary icon-circle-40">
                    <i className="fas fa-calendar-alt fs-14" />
                  </div>
                  <div>
                    <h4 className="mb-0 fw-medium font-size-15">{t("orderTimeline")}</h4>
                    <span className="text-secondary fw-normal font-size-13">
                      {order?.StartDate && order?.EndDate
                        ? `${moment(order.StartDate).format("DD-MM-YYYY")} – ${moment(order.EndDate).format("DD-MM-YYYY")}`
                        : "--"}
                    </span>
                  </div>
                </div>
              </Col>

              <Col md={4} className="ps-md-3 border-md-start border-md-secondary h-40">
                <div className="d-flex align-items-center gap-3 w-100">
                  <div className="d-flex align-items-center justify-content-center rounded-circle bg-warning-subtle text-warning icon-circle-40">
                    <i className="fas fa-clock fs-14" />
                  </div>
                  <div>
                    <h4 className="mb-0 fw-medium font-size-15">{t("schedule")}</h4>
                    <span className="text-secondary fw-normal font-size-13">
                      {order?.StartTime
                        ? order?.EndTime
                          ? `${formatStoredTime(order.StartTime)} – ${formatStoredTime(order.EndTime)}`
                          : formatStoredTime(order.StartTime)
                        : "--"}
                    </span>
                  </div>
                </div>
              </Col>

              <Col md={4} className="ps-md-1 border-md-start border-md-secondary h-40">
                <div className="position-relative pt-1">
                  <div className="d-flex justify-content-between position-relative">
                    <div className="position-absolute bg-300 timeline-line" />
                    {/* <div className="position-absolute bg-primary timeline-progress" /> */}
                    {[
                      { label: t("inspectionTimeline"), active: true },
                      { label: t("execution"), active: false },
                      { label: t("qualityCheck"), active: false },
                      { label: t("completed"), active: false }
                    ].map((step, idx) => (
                      <div key={idx} className="text-center position-relative timeline-step">
                        <div
                          className={`rounded-circle mx-auto timeline-dot ${step.active ? "bg-primary" : "bg-300"}`}
                        />
                        <span
                          className={`mt-2 px-1 timeline-label d-block font-size-13 ${step.active ? "text-primary fw-medium" : "text-muted"}`}
                        >
                          {step.label}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="g-3 mb-3 justify-content-center">
              <Col lg={12} xxl={12}>
                <Tabs
                  activeKey={activeTab}
                  onSelect={(key) => {
                    setActiveTab(key);
                    if (key === "planning" && calendarRef.current) {
                      setTimeout(() => {
                        calendarRef.current.getApi().updateSize();
                      }, 200);
                    }
                  }}
                  id="order-details-tabs"
                  transition={false}
                >
                  <Tab
                    eventKey="overview"
                    title={t("overview")}
                    className="border-bottom border-x p-3"
                  >
                    <Overview
                      todayProgress={todayProgress}
                      relationData={relationData}
                      todayTasks={todayTasks}
                      weekTasks={weekTasks}
                      t={t}
                      onInventoryClick={handleInventoryClick}
                      onViewAllHistory={handleViewAllHistory}
                      onViewAllTasks={handleViewAllTasks}
                      todayEmployees={todayEmployees}
                    />
                  </Tab>

                  <Tab
                    eventKey="planning"
                    title={t("planning")}
                    className="border-bottom border-x p-3"
                  >
                    <div className="calendar-wrapper mt-3 position-relative">
                      {!calendarReady && (
                        <div className="text-center my-5">
                          <Spinner animation="border" role="status">
                            <span className="visually-hidden">{t("loading")}</span>
                          </Spinner>
                        </div>
                      )}

                      {calendarReady && weekDetailsLoading && (
                        <div
                          className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                          style={{ backgroundColor: "rgba(255,255,255,0.6)", zIndex: 5 }}
                        >
                          <Spinner animation="border" role="status">
                            <span className="visually-hidden">{t("loading")}</span>
                          </Spinner>
                        </div>
                      )}

                      <div className={calendarReady ? "calendar-visible" : "calendar-hidden"}>
                        {renderEmployeeOverviewCalendar()}
                      </div>
                    </div>
                  </Tab>

                  <Tab
                    eventKey="taskExecution"
                    title={t("taskExecution")}
                    className="border-bottom border-x p-3"
                  >
                    <Card className="border-0 shadow-sm">
                      <Card.Body className="text-center py-5">
                        <div className="text-center py-5">{t("NoDataFound")}</div>
                      </Card.Body>
                    </Card>
                  </Tab>

                  <Tab
                    eventKey="inspection"
                    title={t("inspection")}
                    className="border-bottom border-x p-3"
                  >
                    <InspectionLog />
                  </Tab>

                  <Tab
                    eventKey="inventery"
                    title={t("inventory")}
                    className="border-bottom border-x p-3"
                  >
                    <Inventory />
                  </Tab>

                  <Tab
                    eventKey="orderhistory"
                    title={t("orderHistory")}
                    className="border-bottom border-x p-3"
                  >
                    <OrderHistory relationId={order?.RelationId} />
                  </Tab>
                </Tabs>
              </Col>
            </Row>
          </Card>
        </Col>
      )}

      <TaskDrawer
        open={drawerOpen}
        onClose={handleDrawerClose}
        selectedTask={selectedTask}
        loading={detailsLoading}
        t={t}
        renderStatusBadge={renderTaskStatusBadge}
        userRole={userRole}
        disableStartTimeUpdate={true}
        context="orderDetails"
        allEmployees={locationEmployees}
        onRemoveCleaner={openCleanerDeleteModal}
        fetchOrderDetails={() => fetchWeekDetails(weekStart)}
        conflictMap={conflictMap}
      />

      <UnavailabilitySidepanel
        open={leaveDrawerOpen}
        onClose={() => {
          setLeaveDrawerOpen(false);
          setSelectedLeaveData(null);
        }}
        data={selectedLeaveData}
        mode="readonly"
        t={t}
      />

      <OrderDeleteModal
        show={showOrderDeleteModal}
        handleClose={() => setShowOrderDeleteModal(false)}
        handleDelete={handleOrderDelete}
      />
      <CleanerDeleteModal
        show={showCleanerDeleteModal}
        onClose={() => {
          setShowCleanerDeleteModal(false);
          setSelectedOrderDetailId(null);
          setSelectedEmployeeId(null);
          setSelectedTaskDate(null);
        }}
        onRemoveThis={handleConfirmDeleteCleaner}
        onRemoveAll={handleRemoveAllCleanersForDay}
        t={t}
      />

      {showAssignModal && (
        <Modal
          show={showAssignModal}
          onHide={() => {
            setShowAssignModal(false);
            setSelectedCleaners([]);
            setSelectedDateForAssign(null);
            setSelectedProposalTask(null);
          }}
          centered
          backdrop="static"
          keyboard={false}
          className={pendingSchedulingIssues ? "d-none" : ""}
        >
          <Modal.Header closeButton>
            <Modal.Title className="text-muted fs-9">
              {t("assignCleaner")} {t("to")}{" "}
              {selectedDateForAssign?.format("dddd, DD MMM YYYY")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>{t("selectTask")}</Form.Label>
              <Select
                options={
                  selectedDateForAssign
                    ? taskWithSubtasks
                      .filter((task) =>
                        task.recurrence?.selectedDays?.includes(
                          selectedDateForAssign.format("dddd").toLowerCase()
                        )
                      )
                      .map((task) => ({
                        value: task,
                        label: task.taskName,
                      }))
                    : []
                }
                value={
                  selectedProposalTask
                    ? {
                      value: selectedProposalTask,
                      label: selectedProposalTask.taskName,
                    }
                    : null
                }
                onChange={(selectedOption) =>
                  setSelectedProposalTask(selectedOption?.value || null)
                }
                placeholder={t("select")}
                isClearable
                className="custom-select-container"
                classNamePrefix="custom-select"
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>{t("selectCleaner")}</Form.Label>
              <Select
                noOptionsMessage={() => t("noOptionsAvailable")}
                isMulti
                closeMenuOnSelect={false}
                placeholder={t("select")}
                options={recommendedEmployeeGroups?.recommended?.length > 0 ? [
                  {
                    label: t("recommendedEmployees"),
                    options: recommendedEmployeeGroups.recommended.map(cleaner => ({
                      value: cleaner.UserId,
                      label: cleaner.Name,
                    })),
                  },
                  {
                    label: t("allEmployees"),
                    options: recommendedEmployeeGroups.others.map(cleaner => ({
                      value: cleaner.UserId,
                      label: cleaner.Name,
                    })),
                  },
                ] : sortEmployeesAscending(locationEmployees).map(cleaner => ({
                  value: cleaner.UserId,
                  label: cleaner.Name,
                }))}
                value={locationEmployees
                  .filter(cleaner => selectedCleaners.includes(cleaner.UserId))
                  .map((cleaner) => ({
                    value: cleaner.UserId,
                    label: cleaner.Name,
                  }))}
                onChange={(selected) =>
                  handleAddCleanersForDay((selected || []).map((item) => item.value), false)
                }
              />
            </Form.Group>

            {selectedCleaners?.length > 0 && (
              <div className="mt-3 d-flex flex-wrap gap-2">
                {selectedCleaners.map((id) => {
                  const cleaner = locationEmployees.find((c) => c.UserId === id);
                  if (!cleaner) return null;

                  return (
                    <div
                      key={id}
                      className="d-flex align-items-center px-3 py-1 rounded-pill bg-light border text-dark small shadow-sm"
                    >
                      <FontAwesomeIcon
                        icon="user"
                        className="me-2 text-primary"
                      />
                      <span className="fw-semibold">{cleaner.Name}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              size="sm"
              variant="falcon-default"
              onClick={() => {
                setShowAssignModal(false);
                setSelectedCleaners([]);
                setSelectedDateForAssign(null);
                setSelectedProposalTask(null);
              }}
            >
              {t("cancel")}
            </Button>

            <Button
              size="sm"
              variant="primary"
              onClick={() => handleAddCleanersForDay(selectedCleaners, true)}
              disabled={
                isAssigning ||
                !selectedProposalTask ||
                !selectedCleaners ||
                selectedCleaners.length === 0
              }
            >
              {isAssigning ? (
                t("saving")
              ) : (
                t("assign")
              )}
            </Button>

          </Modal.Footer>
        </Modal>
      )}

      <SchedulingIssuesModal
        show={!!pendingSchedulingIssues}
        issues={pendingSchedulingIssues?.issues || []}
        t={t}
        onCancel={() => {
          setPendingSchedulingIssues(null);
        }}
        onConfirm={async () => {
          const { cleanersList, closeModal } = pendingSchedulingIssues || {};
          setPendingSchedulingIssues(null);
          if (cleanersList) setSelectedCleaners(cleanersList);
          if (closeModal) await proceedAddCleaners(cleanersList);
        }}
      />

      <Modal
        size="lg"
        show={showProposalModal}
        onHide={() => setShowProposalModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{proposalTemplateName || t("proposal")}</Modal.Title>
        </Modal.Header>

        <Modal.Body className="proposal-modal-body">

          {pdfLoading && (
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" />
            </div>
          )}

          {!pdfLoading && pdfError && (
            <div className="text-center text-muted py-5">
              {pdfError}
            </div>
          )}

          {!pdfLoading && proposalPdfUrl && (
            <PDFVierwer
              pdfUrl={proposalPdfUrl}
              onRendered={() => setPdfLoading(false)}
            />
          )}

        </Modal.Body>
      </Modal>
    </>
  );
};

export default OrderDetails;